import 'twin.macro';
import React from 'react';
import { Classroom } from '@teetsh/app/src/types/classroom';
import { EDTEvent } from '@teetsh/app/src/types/edt';
import { Color } from '@teetsh/app/src/types/colors';
import { getVolumeFromEDTEvents } from './getVolumeFromEDTEvents';
import { TagList } from '.';
import { Element } from './Details';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { getFilteredEDTEvents } from './getFilteredEDTEvents';
import { ExcludedEvents } from './ExcludedEvents';
import { useUpdateEdtSeance } from '@teetsh/app/src/queries/edt/useUpdateEdtSeance';

export interface TagHour {
  minutes: number;
  tag: string;
  elements: Element[];
}

interface Props {
  events: EDTEvent[];
  classrooms: Classroom[];
  edtStartTime: Date;
  edtEndTime: Date;
  edtId: string;
}

export function EDTEventsTagList(props: Props) {
  const { events, classrooms, edtStartTime, edtEndTime, edtId } = props;
  const { locale } = useUser();
  const updateEdtSeance = useUpdateEdtSeance(edtId);

  // Filter events within time range
  const filteredEvents = getFilteredEDTEvents(
    events,
    classrooms,
    edtStartTime,
    edtEndTime,
  );

  // Separate excluded events (skipFromVolume: true)
  const excludedEvents = filteredEvents.filter(event => event.skipFromVolume);

  // Get volume data for non-excluded events
  const classroomsWithTags = getVolumeFromEDTEvents(
    filteredEvents,
    classrooms,
    locale,
  );

  const handleIncludeEvent = (event: EDTEvent) => {
    updateEdtSeance({
      ...event,
      skipFromVolume: false,
    });
  };

  return (
    <>
      <ExcludedEvents
        tw="mb-6"
        excludedEvents={excludedEvents}
        onIncludeEvent={handleIncludeEvent}
      />
      <TagList
        groups={classroomsWithTags.map(cl => ({
          id: cl.classroomName,
          name: cl.classroomName,
          items: cl.tags.map(tag => ({
            id: tag.tag,
            minutes: tag.minutes,
            color: tag.tag.split('%%')[1] as Color,
            name: tag.tag.split('%%')[0],
            elements: tag.elements,
          })),
        }))}
      />
    </>
  );
}
